import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: '5f059d0f-1a5b-4033-91df-458a1c77dd32',
    authority: 'https://login.microsoftonline.com/f1502c4c-ee2e-411c-9715-c855f6753b84',
    redirectUri: 'https://cee-upload-h2bbdge4exgugjc6.westeurope-01.azurewebsites.net',
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);